import { Module } from 'vuex'

interface ProgrammingCategoryRatingState {
  chartData: { labelChartData: string[][]; categoryRatingChartData: number[][]; maxRating: number }
  chartSeries: any[]
  chartOptions: any
  hasData: boolean
}

export const programmingCategoryRatingModule = (): Module<ProgrammingCategoryRatingState, any> => {
  return {
    namespaced: true,
    state: {
      chartData: { labelChartData: [], categoryRatingChartData: [], maxRating: 0 },
      chartSeries: [],
      chartOptions: {},
      hasData: false
    },
    mutations: {
      setChartData(
        state,
        chartData: { labelChartData: string[][]; categoryRatingChartData: number[][]; maxRating: number }
      ) {
        state.chartData = chartData
      },
      setChartSeries(state, chartSeries: any[]) {
        state.chartSeries = chartSeries
      },
      setChartOptions(state, chartOptions: any) {
        state.chartOptions = chartOptions
      },
      setHasData(state, hasData: boolean) {
        state.hasData = hasData
      }
    },
    actions: {},
    getters: {
      chartData: state => state.chartData,
      chartSeries: state => state.chartSeries,
      chartOptions: state => state.chartOptions,
      hasData: state => state.hasData
    }
  }
}
